export default "__VITE_ASSET__33708990__"